
import HeartIcon from "@/components/marketAnalysis/icons/HeartIcon";
import HeartIconFilled from "@/components/marketAnalysis/icons/HeartIconFilled";
import NextIcon from "@/components/marketAnalysis/icons/NextIcon";
import UserTickIcon from "@/components/marketAnalysis/icons/UserTickIcon";
import MarketAnalysisFAQDialog from "@/components/marketAnalysis/MarketAnalysisFAQDialog";
import subscriptionConstants from '@/constants/subscription.constants';
import MarketAnalysisService from "@/service//MarketAnalysisService";

const { subscribeProductKeys, subscriptionPlans } = subscriptionConstants;

export default {
    name: 'MarketAnalysisFAQ',

    components: {
        NextIcon,
        UserTickIcon,
        HeartIcon,
        HeartIconFilled,
        MarketAnalysisFAQDialog,
    },

    data() {
        return {
            isLoading: false,
            questions: [],
            isFAQDialogVisible: false,
            selectedFaq: {},
        }
    },

    computed: {
        infoIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/info-dark.svg') :
                require('@/assets/icons/info-light.svg');
        },
        finAgentIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/fin-agent-answer-avatar-dark.svg') :
                require('@/assets/icons/fin-agent-answer-avatar-light.svg');
        },
        isLoggedIn() {
            return !!this.$store.state.account.user;
        },
        isSubscribedFinAgent() {
            return this.isLoggedIn && this.$store.state.account.subscribedProductIds?.includes(subscribeProductKeys.finAgent);
        },
    },

    watch: {
        isLoggedIn: {
            handler() {
                this.fetchFAQ()
            },
            immediate: true
        },
        isFAQDialogVisible(state) {
            if (!state) {
                this.selectedFaq = {}
            }
        }
    },

    created() {
        this.marketAnalysisService = new MarketAnalysisService(this.$axios)
        this.fetchFAQ()
    },

    methods: {
        async fetchFAQ() {
            try {
                this.isLoading = true
                if (this.currentRequest) {
                    await this.currentRequest.cancel()
                }
                const axiosSource = this.$axios.CancelToken.source();
                this.currentRequest = { cancel: axiosSource.cancel }
                const lang = this.$getCurrentLocale()
                this.questions = await this.marketAnalysisService.getFAQ(axiosSource.token, lang)
                this.isLoading = false
                const userCountList = this.questions.map(question => question.relatedUserQuestionsCount).sort((a, b) => b - a)
                this.questions = this.questions.map(question => {
                    const index = userCountList.findIndex(e => e === question.relatedUserQuestionsCount)
                    return {...question, class: `question-color-${index > 9 ? 10 : index + 1}`}
                })
            } catch (err) {
                if (this.$axios.isCancel(err)) {
                    throw err
                }
                this.questions = []
                this.isLoading = false
            }
        },
        handleClickHeartIcon(event, id, isLiked) {
            if (!this.isLoggedIn) {
                return
            }
            event.stopPropagation()
            if (isLiked) {
                this.dislikeFAQ(id)
            } else {
                this.likeFAQ(id)
            }
        },
        async likeFAQ(id) {
            this.questions = this.questions.map(question => {
                if (question.id === id) {
                    question.liked = true
                    question.likes += 1
                }
                return question
            })
            await this.marketAnalysisService.likeFAQ(id)
        },
        async dislikeFAQ(id) {
            this.questions = this.questions.map(question => {
                if (question.id === id) {
                    question.liked = false
                    question.likes -= 1
                }
                return question
            })
            await this.marketAnalysisService.dislikeFAQ(id)
        },
        checkNavigateFinAgent() {
            if (!this.isSubscribedFinAgent) {
                this.$router.push({
                    name: this.$getTranslatedRouteName('subscription'),
                    params: { plan: subscriptionPlans.ai }
                })
            }
        },
        openFAQDialog(question) {
            this.selectedFaq = question
            this.isFAQDialogVisible = true
        }
    },
  }
